import { CloseIconButton } from '@src/shared/ui/Button';

const StyleSheet = {
  close: {
    height: '20px',
    width: '20px',
    padding: 0,
    '& .MuiSvgIcon-root': {
      width: '10px',
      height: '10px',
    },
  },
};

type SidebarCloseButtonProp = {
  onClose: () => void;
};
export default function SidebarCloseButton({
  onClose,
}: SidebarCloseButtonProp) {
  return <CloseIconButton sx={StyleSheet.close} onClick={onClose} />;
}
